<template>
  <div>
    <v-dialog
      v-model="isOpen" 
      persistent
      :content-class="expanded ? 'j_modal editor editor_width_full' : 'j_modal editor editor_width_lf'"
      >
      <v-card>

        <v-card-title v-if="!expanded" class="modal__header type_gray">
          <span>
            {{ title }}
            <small>{{ subTitle }}</small>
          </span>
          <j-button class="modal_close second_btn" @click="expanded = !expanded">
            <v-icon>mdi-crop-square</v-icon>
          </j-button>
          <j-button class="modal_close" @click="close">
            <v-icon>mdi-close</v-icon>
          </j-button>
        </v-card-title>

        <div v-else class="modal__header type_gray">
          <span>
            {{ title }}
            <small>{{ subTitle }}</small>
          </span>
          <j-button class="modal_close second_btn full_modal_btn" @click="expanded = !expanded">
            <v-icon>mdi-image-filter-none</v-icon>
          </j-button>
          <j-button class="modal_close" @click="close">
            <v-icon>mdi-close</v-icon>
          </j-button>
        </div>

        <v-card-text>
          <textarea v-model="scripted" name class="type_exp"></textarea>
        </v-card-text>
        <v-card-actions>
          <j-button v-if="buttons.validate" class="type01 sky" text @click="onValidate"
            >Validate</j-button
          >
          <v-spacer></v-spacer>
          <div :class="validClass">
            <pre>{{ message }}</pre>
          </div>
          <v-spacer></v-spacer>
          <j-button v-if="buttons.save && type==='jsonQR'" class="type01 sky" text @click="onPreview">Preview</j-button>
          <j-button v-if="buttons.save" class="type01 sky" text @click="onSave">Save</j-button>
          <j-button class="type01" text @click="close()">{{
            buttons.save ? 'Cancel' : 'Close'
          }}</j-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <j-alert
      v-model="msgOpen"
      :type="msgInfo.type"
      :title="msgInfo.title"
      :title-description="msgInfo.titleDescription"
      :message="msgInfo.message"
      :button="msgInfo.button"
      :button-text="msgInfo.buttonText"
      @yes="yes()"
      @cancel="msgOpen = false"
    ></j-alert>
  </div>
</template>
<script>
export default {
  name: 'j-modal-scripter',
  data: () => ({
    expanded: false,
    // 기존 opened -> 내부 open 상태 ----------------
    isOpen: false, 
    // preview 상태
    isPreview: false,
    // activators --------------------
    msgOpen: false,
    // general -----------------------
    localItem: [],
    msgInfo: {
      type: '',
      title: '',
      titleDescription: '',
      message: '',
      button: [true, false, true],
      buttonText: ['Yes', 'No', 'Cancel'],
    },
  }),
  props: {
    modelValue: { type: String, default: ''},
    buttons: { type: Object, default: () => ({ validate: true, save: true }),},
    message: String,
    opened: { type: Boolean, default: false },
    subTitle: String,
    title: String,
    type: String,
    valid: null,
  },
  emits: ['input', 'update:modelValue', 'close', 'save', 'validate', 'preview'], // 사용할 이벤트 명시적 선언
  computed: {
    scripted: {
      get() { return this.modelValue },
      set(val) { this.$emit('update:modelValue', val) },
    },
    validClass() {
      return this.valid ? 'positive' : 'negative'
    },
    expandedClass() {
      return this.expanded ? 'j_modal editor editor_width_full' : 'j_modal editor editor_width_sm'
    },
  },
  watch: {
    expanded: {
      handler(val) {
        if (!val) return
        this.initModalPos(val)
      },
      deep: true,
    },
    opened(val) {
      // props의 opened 값이 변경되면 내부 상태 업데이트
      this.isOpen = this.isPreview ? true : val
    },
    isOpen(val) {
      if (val && this.type === 'jsonQR') {
        this.$nextTick(() => this.onValidate())
      }
      // 내부 상태가 변경되면 외부에 알림
      if (val !== this.opened && !val) {
        if (!this.isPreview) {
          this.$emit('close')
        }
      }
    }
  },
  mounted() {
    // 초기화 시 props 값으로 내부 상태 설정
    this.isOpen = this.opened
    if (this.isOpen && this.type === 'json') {
      this.$nextTick(() => this.onValidate())
    }
  },
  
  methods: {
    close() {      
      this.onValidate()
      setTimeout(() => {
        if (this.valid || this.scripted === ''|| this.scripted === undefined) {
          this.isOpen = false // opened 대신 isOpen 사용
          // this.$emit('close')
          this.initExpandState()
        } else {
          
          this.yes = () => {
            this.msgOpen = false
            this.yes = () => {}
          }
          this.msgInfo.type = 'WARN'
          this.msgInfo.title = 'VALIDATION ERROR'
          this.msgInfo.titleDescription = 'VALIDATION FAILED'
          this.msgInfo.message = 'Please validate your script before closing'
          this.msgInfo.button = [true, false, false]
          this.msgInfo.buttonText[0] = 'OK'
          this.msgOpen = true
        }
      }, 1000)
    },
    initExpandState() {
      this.expanded = false
    },
    initModalPos(val) {
      if (val) {
        setTimeout(() => {
          // v-dialog j_modal editor editor_width_sm v-dialog--active v-dialog--persistent
          // v-overlay__content j_modal editor editor_width_sm
          document.querySelector('.v-overlay__content.j_modal.editor_width_full').style.position =
            'initial'
        }, 1)
      }
    },
    onSave() {
      this.isPreview = false
      this.onValidate()
      setTimeout(() => {
        if (this.valid || this.scripted === '') {
          this.$emit('save')
          this.isOpen = false
        } else {
          this.yes = () => {
            this.msgOpen = false
            this.yes = () => {}
          }
          this.msgInfo.type = 'WARN'
          this.msgInfo.title = 'VALIDATION ERROR'
          this.msgInfo.titleDescription = 'VALIDATION FAILED'
          this.msgInfo.message = 'Please validate your script before saving'
          this.msgInfo.button = [true, false, false]
          this.msgInfo.buttonText[0] = 'OK'
          this.msgOpen = true
        }
      }, 1000)
    },
    onPreview() {
      this.isPreview = true
      
      this.$emit('validate')
      
      this.$nextTick(() => {
        this.$emit('preview')
        this.isOpen = true
      })
    },
    onValidate() {
      this.$emit('validate')
    },
  },
}
</script>
